import { createContext, useContext, useState, useCallback } from 'react';
import Alert from '../components/ui/Alert';

const AlertContext = createContext(null);

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState(null);

  const showAlert = useCallback((message, type = 'error', duration = 5000) => {
    setAlert({ message, type, duration });
  }, []);

  const showError = useCallback((message, duration = 5000) => {
    showAlert(message, 'error', duration);
  }, [showAlert]);

  const showSuccess = useCallback((message, duration = 3000) => {
    showAlert(message, 'success', duration);
  }, [showAlert]);

  const showWarning = useCallback((message, duration = 4000) => {
    showAlert(message, 'warning', duration);
  }, [showAlert]);

  const showInfo = useCallback((message, duration = 3000) => {
    showAlert(message, 'info', duration);
  }, [showAlert]);

  const hideAlert = useCallback(() => {
    setAlert(null);
  }, []);

  return (
    <AlertContext.Provider 
      value={{ 
        showAlert, 
        showError, 
        showSuccess, 
        showWarning, 
        showInfo, 
        hideAlert 
      }}
    >
      {children}
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          duration={alert.duration}
          onClose={hideAlert}
        />
      )}
    </AlertContext.Provider>
  );
}

export function useAlert() {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
}
